const colors = {
  black: '#000000',
  white: '#FFFFFF',
  grayLight: '#f1f1f1',
  grayDark: '#2a2a2a',
  green: '#44db5f',
  greenDark: '#2f9941',
  red: '#EB0505',
  redDark: 'rgb(164, 3, 3)'
}

const breakpoints = {
  xs: 360,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1920
}

const Theme = {
  ...colors,
  breakpoints,
  bodyFontFamily: 'Arial, sans-serif',
  bodyFontSize: '16px',
  bodyLineHeight: 1.25,
  bodyFontColor: colors.black,
  bodyBackgroundColor: colors.white,
  brandFontFamily: 'Damm Black, Arial, sans-serif',
  brandFontColor: colors.green,
  borderDefault: `1px solid ${colors.black}`,
  transitionDefault: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
  titleFontSize: '40px',
  titleFontSizeMobile: '36px',
  headingCheckout: '1.375rem'
}

export default Theme
